// extracted by mini-css-extract-plugin
export default {"container":"style_container__E2T2A","remark":"style_remark__RAQKO","title":"style_title__+c8xT","redStar":"style_redStar__Rf0ns"};